import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'insecable',
    standalone: true,
})
export class InsecablePipe implements PipeTransform {
    /**
     * The `transform` function in TypeScript replaces all whitespace characters in a string with `&nbsp;`.
     *
     * @param {string} value - The `value` parameter in the `transform` function is a string that
     * represents the input text that needs to be transformed.
     *
     * @returns The `transform` function returns a string with all spaces replaced by `&nbsp;`
     *
     * @example converts string "Text with blank" to string "Text&nbsp;with&nbsp;blank"
     */
    public transform(value: string): string {
        if (!value) {
            return value;
        }

        return value.replace(/\s/gm, '&nbsp;');
    }
}
